import { useColumnControl } from '@/context/columnControlContext.jsx';
import { ListSubheader, MenuItem, useTheme } from '@mui/material';
import { GridColumnMenuContainer } from '@mui/x-data-grid';
import React from 'react';

const DataGridColumnMenu = (props) => {
	const { colDef, hideMenu } = props;
	const { toggleColumn } = useColumnControl();
	const theme = useTheme();

	return (
		<GridColumnMenuContainer
			{...props}
			sx={{
				minWidth: 0,
			}}
		>
			<ListSubheader
				sx={{ lineHeight: '24px', fontWeight: 600, color: theme.palette.text.primary }}
			>
				{colDef.headerName}
			</ListSubheader>
			{colDef.hideable !== false && (
				<MenuItem
					onClick={() => {
						toggleColumn(colDef.field);
						hideMenu?.();
					}}
				>
					Hide column
				</MenuItem>
			)}
		</GridColumnMenuContainer>
	);
};
export default DataGridColumnMenu;
